var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import * as React from 'react';
import { useTheme } from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import Icon from '../../../../components/Icon';
import { PrimaryCTAStyles, PrimaryButtonWrapperSpanStyles, PrimaryButtonThemeConfig, } from '../styles';
import { ProgressIndicator } from '../../../../components/ProgressIndicator';
import { ColorContextProvider } from '../../../providers/ColorContext';
export const PrimaryButton = (_a) => {
    var { children, icon = 'arrowRight', isPending, title, backgroundColor: backgroundColorProp } = _a, props = __rest(_a, ["children", "icon", "isPending", "title", "backgroundColor"]);
    const { colors, colorContext } = useTheme();
    const backgroundColor = backgroundColorProp || (colorContext === 'dark' ? 'white' : 'primary');
    // @FIXME
    // No info of React.ElementType / Generic ('button', 'span', etc)
    // @ts-expect-error: disabled is not defined
    const isDisabled = props.disabled;
    const dataTestIdBase = props['data-testid'] || `primary-button--${backgroundColor}`;
    const config = PrimaryButtonThemeConfig[backgroundColor][isDisabled ? 'disabled' : 'default'];
    return (React.createElement(ColorContextProvider, { backgroundColor: colors[backgroundColor] },
        React.createElement(PrimaryCTAStyles, Object.assign({}, props, { "data-testid": dataTestIdBase, title: title || children, config: config }),
            React.createElement(PrimaryButtonWrapperSpanStyles, null,
                children,
                isPending ? (React.createElement(ProgressIndicator, { "data-testid": `${dataTestIdBase}__pending`, width: "1rem", height: "1rem", fillColor: config.color })) : (React.createElement(Icon, { "data-testid": `${dataTestIdBase}__icon--${icon}`, type: icons[icon], width: "1rem", height: "1rem", fillAll: colors[config.color] }))))));
};
